export { useTextDirection, TextDirectionProvider } from './text-direction-provider';

export type { TextDirection } from './text-direction-provider';
